import { StyleSheet } from 'lib/paypalphrodite'
import { largeAndSmaller } from '../../lib/styles/media-queries';

export default StyleSheet.create({
  wrapper: {
    textAlign: 'center',
    overflow: 'auto',
    color: 'white',
    paddingBottom: 50,
    [largeAndSmaller]: {
      // fix horizontal and vertical scrollbars on iOS in the inner container
      overflow: 'hidden',
    },
  },
  header: {
    margin: '25px 40px 0 40px',
    color: 'white',
  },
  attribution: {
    display: 'inline-block',
    margin: '8px 0 15px',
    '@media (max-width: 1024px)': {
      margin: '8px 0 8px',
    },
  },
  attributionImage: {
    display: 'inline-block',
    width: 22,
    height: 22,
    borderRadius: '50%',
    position: 'relative',
    top: 6,
    left: 6,
    backgroundSize: 'cover',
  },
  background: {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    position: 'fixed',
    transition: 'opacity 300ms',
  },
  foreground: {
    position: 'relative',
  },
  cardGroupWrapper: {
    position: 'relative', // so the absolutely positioned cards within are positioned with respect to this
    width: 357,
    height: 500,
    margin: '0 30px 0 30px',
    float: 'left',
    overflow: 'visible', // so cards animating in aren't cut off
    '@media (max-width: 1024px)': {
      float: 'none',
      margin: 0,
    },
    '@media (max-width: 450px)': {
      float: 'none',
      margin: 0,
      width: 300,
      height: 375,
      left: 20,
    },
  },
  flipWrapper: {
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.35)',
    width: 60,
    height: 60,
    borderRadius: '50%',
    border: 'none',
    padding: 10,
    cursor: 'pointer',
    color: 'white',
    zIndex: 1001, // required because of crazy css 3d space stuff and the card perspective being set to 1000px
    outline: 'none',
    '@media (max-width: 1024px)': {
      position: 'absolute',
      top: 85,
      right: 20,
    },
    '@media (max-width: 450px)': {
      position: 'absolute',
      top: 75,
      right: 30,
      width: 55,
      height: 55,
      padding: 7,
    },
    ':focus': {
      outline: 'auto',
    },
  },
  flipIcon: {
    fill: 'none',
    stroke: 'white',
    width: 20,
    strokeWidth: 2,
    padding: 2,
  },
  buttonEl: {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 9,
    cursor: 'pointer',
    outline: 'none',
    transition: 'opacity 300ms ease',
    '@media (max-width: 1024px)': {
      margin: '0 6px 20px',
    },
    '@media (max-width: 450px)': {
      margin: '0 5px 20px',
    },
    ':hover': {
      opacity: '1 !important',
    },
    ':focus': {
      opacity: '1 !important',
      outline: 'auto',
    },
  },
  iconsWrapper: {
    width: '75px',
    float: 'left',
    '@media (max-width: 1024px)': {
      width: '100%',
      float: 'none',
    },
  },
  themeIcon: {
    backgroundSize: '105%',
    boxShadow: '0px 2px 1px 0px rgba(0,0,0,0.20)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    width: 65,
    height: 65,
    '@media (max-width: 1024px)': {
      width: 48,
      height: 48,
    },
    '@media (max-width: 450px)': {
      width: 40,
      height: 40,
    },
  },
  centerPiece: {
    // wraps both theme icons, cards, and flip button — necessary to center on card
    margin: '0 auto', // center the whole thing, then...
    right: 37, // ...then shift the whole thing so cards are centered
    overflow: 'visible',
    display: 'inline-block',
    position: 'relative',
    '@media (max-width: 1024px)': {
      right: 0,
      margin: '10px 0',
    },
  },
  nextButton: {
    margin: '25px auto 0',
    display: 'block',
    width: 275,
  },
  cancelButton: {
    display: 'block',
    width: 250,
    margin: '20px auto 0',
    color: 'white',
  },
  removeButton: {
    display: 'block',
    width: 250,
    margin: '20px auto 0',
    color: 'white',
  },
})
